import { createStore } from "easy-peasy";
import companyProfile from "./companyProfile";

const store = createStore({
  companyProfile
});

export default store;
